var EventEmitterMixin = require("../../mixins/event-emitter.mixin");

var NewsSubscriptionFormComponent = function () {
    var self = this;
    var $currentContext = $();

    this.getData = function() {
        return $currentContext.serializeArray();
    }

    function bindEvents() {
        $currentContext.on("input", () => self._raiseEvent("form-updated"));
        $currentContext.on("submit", function(e) {
            e.preventDefault();
            if($currentContext.valid()) {
                self._raiseEvent("form-submitted", self.getData());
            }
        })
    }

    function parseContext() {
        action = $currentContext.attr("action");
    }

    this.init = function ($context) {
        $currentContext = $context || $currentContext;

        parseContext();
        bindEvents();
    };
};

Object.assign(NewsSubscriptionFormComponent.prototype, new EventEmitterMixin());

Object.defineProperty(NewsSubscriptionFormComponent, "SELECTOR", {
    enumerable: false,
    configurable: false,
    writable: false,
    value: ".js-new-subscription__form"
});

module.exports = NewsSubscriptionFormComponent;
